import React, { useState } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

export interface ModalSelectionOption {
  key: string
  label: string
}

interface ModalSelectionProps {
  description: React.ReactNode
  options: ModalSelectionOption[]
  onChange: (selected: ModalSelectionOption) => void
}

const BRAND_BLUE = '#1B4AA0'

const ModalSelection: React.FC<ModalSelectionProps> = ({
  description,
  options,
  onChange
}) => {
  const [selectedKey, setSelectedKey] = useState<string>(options[0]?.key ?? '')

  const handleSelect = (opt: ModalSelectionOption) => {
    setSelectedKey(opt.key)
    onChange(opt)
  }

  return (
    <Stack spacing={2}>
      {/* Description row */}
      <Stack direction='row' spacing={1.5} alignItems='flex-start'>
        <WarningAmberRoundedIcon
          sx={{ color: '#E5A800', mt: '2px', flexShrink: 0 }}
        />
        <Typography fontSize={14} color='text.secondary'>
          {description}
        </Typography>
      </Stack>

      {/* Option list */}
      <Stack spacing={1}>
        {options.map((opt) => {
          const isSelected = opt.key === selectedKey
          return (
            <Box
              key={opt.key}
              onClick={() => handleSelect(opt)}
              sx={{
                px: 2,
                py: 1.5,
                border: '1.5px solid',
                borderColor: isSelected ? BRAND_BLUE : 'divider',
                borderRadius: 1.5,
                cursor: 'pointer',
                bgcolor: isSelected ? '#EEF3FB' : 'background.paper',
                transition: 'border-color 0.15s, background-color 0.15s'
              }}
            >
              <Typography
                fontSize={14}
                fontWeight={isSelected ? 500 : 400}
                color={isSelected ? BRAND_BLUE : 'text.primary'}
              >
                {opt.label}
              </Typography>
            </Box>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default ModalSelection
